import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";

import {observer} from "mobx-react";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import React from "react";
import {
    ContainerButtonMoveScrollToBottom
} from "@dropDesk/presentation/components/buttons/button_navigate_to_bottom/styled";
import {Brightness} from "@dropDesk/domain/entities/theme/colors.entity";


const ButtonNavigateToBottom = observer((
    {
        onClick
    }: {
        onClick: () => void
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const isDarkTheme = colors.brightness === Brightness.dark;

    return (
        <ContainerButtonMoveScrollToBottom
            background={colors.accent}
            isDarkTheme={isDarkTheme}
            onClick={onClick}
        >
            <DropDeskIcon
                icon={ICONS_DROPDESK.downArrow}
                size={22}
                color={SharedColors.white}
                style={{marginTop: 3}}
            />
        </ContainerButtonMoveScrollToBottom>
    );
});
export default ButtonNavigateToBottom;
